import { DatePipe } from '@angular/common';
import { POSITION_OPTIONS } from '@ng-web-apis/geolocation';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { isDevMode, NgModule, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { OnlineStatusModule } from 'ngx-online-status';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './authentication/login/login.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { SignUpComponent } from './authentication/sign-up/sign-up.component';
import { DevComponent } from './dev/dev.component';
import { AddLogbookDialogComponent } from './dialogs/add-logbook-dialog/add-logbook-dialog.component';
import { AddNetDialogComponent } from './dialogs/add-net-dialog/add-net-dialog.component';
import { AddSpeciesDialogComponent } from './dialogs/add-species-dialog/add-species-dialog.component';
import { ContactInfoDialogComponent } from './dialogs/contact-info-dialog/contact-info-dialog.component';
import { DisclaimerDialogComponent } from './dialogs/disclaimer-dialog/disclaimer-dialog.component';
import { OffloadTableDialogComponent } from './dialogs/offload-table-dialog/offload-table-dialog.component';
import { ActiveTripHomeComponent } from './home/active-trip-home/active-trip-home.component';
import { NoTripHomeComponent } from './home/no-trip-home/no-trip-home.component';
import { MaterialModule } from './material/material.module';
import { FisheryNoticesComponent } from './menu-items/fishery-notices/fishery-notices.component';
import { ProfileComponent } from './menu-items/profile/profile.component';
import { RecordsPageComponent } from './menu-items/records-page/records-page.component';
import { ResourcesComponent } from './menu-items/resources/resources.component';
import { MenuComponent } from './menu/menu.component';
import { CancelReportComponent } from './reports/cancel-report/cancel-report.component';
import { GillNetReportComponent } from './reports/catch-reports/gill-net-report/gill-net-report.component';
import { SeineReportComponent } from './reports/catch-reports/seine-report/seine-report.component';
import { TrollReportComponent } from './reports/catch-reports/troll-report/troll-report.component';
import { EndReportComponent } from './reports/end-report/end-report.component';
import { OffloadReportComponent } from './reports/offload-report/offload-report.component';
import { PauseReportComponent } from './reports/pause-report/pause-report.component';
import { StartReportComponent } from './reports/start-report/start-report.component';
import { SubmissionPage } from './reports/submission-page/submission-page.component';
import { TelInputComponent } from './tel-input/tel-input.component';
import { SpeciesAtRiskReportComponent } from './reports/species-at-risk-report/species-at-risk-report.component';

export let InjectorInstance: Injector;
import { LostRecoveredGearFormComponent } from './reports/lost-recovered-gear-form/lost-recovered-gear-form.component';
import { MarineMammalInteractionFormComponent } from './reports/marine-mammal-interaction-form/marine-mammal-interaction-form.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { CoordinateDialogComponent } from './dialogs/coordinate-dialog/coordinate-dialog.component';
import { PrivacyHarvesterDialogComponent } from './authentication/privacy-harvester-dialog/privacy-harvester-dialog.component';
import { LanguageToggleComponent } from './home/language-toggle/language-toggle.component';
import { SanitizeUrlPipe } from './pipes/sanitize-url.pipe';
import { AdminPanelComponent } from './admin-panel/admin-panel.component';
import { EditMappingDialogComponent } from './dialogs/edit-mapping-dialog/edit-mapping-dialog.component';
import { AddVesselDialogComponent } from './dialogs/add-vessel-dialog/add-vessel-dialog.component';
import { FinDialogComponent } from './dialogs/fin-dialog/fin-dialog.component';
import { TripsDialogComponent } from './admin-panel/trips-dialog/trips-dialog.component';
import { HelpComponent } from './menu-items/help/help.component';

@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        AddSpeciesDialogComponent,
        SignUpComponent,
        TelInputComponent,
        PauseReportComponent,
        CancelReportComponent,
        SubmissionPage,
        StartReportComponent,
        EndReportComponent,
        GillNetReportComponent,
        AddNetDialogComponent,
        SeineReportComponent,
        TrollReportComponent,
        NoTripHomeComponent,
        MenuComponent,
        ActiveTripHomeComponent,
        OffloadReportComponent,
        ProfileComponent,
        RecordsPageComponent,
        OffloadTableDialogComponent,
        ContactInfoDialogComponent,
        ResourcesComponent,
        AddLogbookDialogComponent,
        FisheryNoticesComponent,
        DevComponent,
        DisclaimerDialogComponent,
        ResetPasswordComponent,
        SpeciesAtRiskReportComponent,
        LostRecoveredGearFormComponent,
        MarineMammalInteractionFormComponent,
        ConfirmationDialogComponent,
        CoordinateDialogComponent,
        PrivacyHarvesterDialogComponent,
        LanguageToggleComponent,
        SanitizeUrlPipe,
        AdminPanelComponent,
        EditMappingDialogComponent,
        AddVesselDialogComponent,
        FinDialogComponent,
        TripsDialogComponent,
        HelpComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        PdfViewerModule,
        MaterialModule,
        MatIconModule,
        FormsModule,
        ReactiveFormsModule,
        OnlineStatusModule,
        ToastrModule.forRoot(),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerImmediately'
        }),
        BrowserAnimationsModule,
        NgbTimepickerModule], providers: [
        DatePipe,
        {
            provide: POSITION_OPTIONS,
            useValue: { enableHighAccuracy: true },
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {

  constructor(private injector: Injector) 
  {
    InjectorInstance = this.injector;
  }
  
}
